/* Modello: împarte meniul din antet în două grupuri echilibrate, în stânga și în dreapta logo-ului. */
(function () {
  var timer = null;

  function split() {
    var list = document.querySelector('#header-component .header__row--bottom overflow-list');
    if (!list) return;
    var items = Array.prototype.filter.call(list.children, function (e) {
      return e.matches && e.matches('li.menu-list__list-item:not([slot])');
    });
    items.forEach(function (e) { e.classList.remove('mh-split-after'); e.style.marginInlineStart = ''; e.style.marginInlineEnd = ''; });
    if (items.length < 2) return;
    var w = items.map(function (e) { return e.getBoundingClientRect().width; });
    var total = w.reduce(function (a, b) { return a + b; }, 0);
    var acc = 0, best = 0, diff = Infinity;
    for (var i = 0; i < items.length - 1; i++) {
      acc += w[i];
      var d = Math.abs(acc - (total - acc));
      if (d < diff) { diff = d; best = i; }
    }
    items[best].classList.add('mh-split-after');
    /* cele două jumătăți au lățimi diferite: completăm jumătatea mai îngustă cu un spațiu la capătul dinspre margine, ca logo-ul să stea exact la mijlocul golului */
    var left = 0;
    for (var j = 0; j <= best; j++) left += w[j];
    var right = total - left;
    if (!(window.matchMedia && window.matchMedia('(min-width: 1400px)').matches)) return;
    if (left < right) items[0].style.marginInlineStart = (right - left) + 'px';
    else if (right < left) items[items.length - 1].style.marginInlineEnd = (left - right) + 'px';
  }

  function later() {
    clearTimeout(timer);
    timer = setTimeout(split, 60);
  }

  function init() {
    split();
    var header = document.querySelector('#header-component');
    if (header && 'MutationObserver' in window) {
      new MutationObserver(later).observe(header, { childList: true, attributes: true, attributeFilter: ['slot'], subtree: true });
    }
    window.addEventListener('resize', later);
    window.addEventListener('load', later);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
    setTimeout(split, 500);
    setTimeout(split, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', later);
})();
